<template>
  <ReportLayoutBase v-if="isReportInitialized">
    <div class="report-settings-layout__selectors">
      <a nohref class="report-settings-layout__link" data-cy="back-to-journey-page-button" @click="goBack">
        <UgIcon class="report-settings-layout__link-icon" icon="arrow-left" width="16" height="16" />
        <span>{{ t("return") }}</span>
      </a>

      <DeviceCategorySelector v-model="deviceCategory" />

      <span class="report-settings-layout__period-text text-one-line">
        {{ periodInText }}
      </span>
    </div>

    <hr class="selector-separator" />

    <RouterView
      :period="selectedPeriod"
      :preset="selectedPreset"
      :device-category="deviceCategory"
      data-cy="report-settings-layout__main-content"
    />
  </ReportLayoutBase>
</template>

<script setup lang="ts">
import { UgIcon } from "@bebit/atomic";
import { DATE_PERIOD_FORMAT } from "@bebit/utils";
import { format } from "date-fns";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import DeviceCategorySelector from "@host/components/condition-selectors/DeviceCategorySelector.vue";
import { useReport } from "@host/composables/useReport";
import ReportLayoutBase from "./_ReportLayoutBase.vue";

const { t } = useI18n();
const router = useRouter();

const { deviceCategory, selectedPeriod, selectedPreset, isReportInitialized } = useReport();

const periodInText = computed(() => {
  return t("periodInText", {
    startDate: format(selectedPeriod.value.start, DATE_PERIOD_FORMAT.ui),
    endDate: format(selectedPeriod.value.end, DATE_PERIOD_FORMAT.ui),
  });
});

function goBack() {
  router.push({ name: "Journey" });
}
</script>

<style lang="scss">
.report-settings-layout__selectors {
  display: flex;
  height: 64px;
  width: auto;
  align-items: center;
  padding: 0 20px;
}

.selector-separator {
  margin: 0 20px;
  height: 1px;
  background-color: $colorBase500;
  border: none;
}

.report-settings-layout__period-text {
  color: $colorGray1000;
  font-size: 13px;
  font-weight: 400;
}

.report-settings-layout__link {
  align-items: center;
  display: inline-flex;
  line-height: 1;
  cursor: pointer;
  padding-right: 20px;
  margin-right: 20px;
  border-right: 1px solid $colorBase500;
}

.report-settings-layout__link-icon {
  margin-right: 6px;

  path {
    fill: $colorBlueA200;
  }
}
</style>

<i18n lang="yaml">
en:
  return: Return
  periodInText: "period: { startDate } - { endDate }"
ja:
  return: 戻る
  periodInText: "期間: { startDate } - { endDate }"
zh-hant:
  return: 返回
  periodInText: "期間: { startDate } - { endDate }"
zh-hans:
  return: 返回
  periodInText: "期間: { startDate } - { endDate }"
</i18n>
